import React, { useState } from 'react';

import { Typography } from '@mui/material';
import { useEffectOnce } from 'react-use';

import { FixedModal } from '@components/modals/FixedModal';

import { checkCookiesEnabled } from './CookiesChecker.utilities';
import { CookiesErrorContent } from './CookiesErrorContent';

export const CookiesChecker: React.FC = () => {
  const [cookiesEnabled, setCookiesEnabled] = useState<boolean>(true);

  useEffectOnce(() => {
    // Используем функцию и устанавливаем результат в состояние
    setCookiesEnabled(checkCookiesEnabled());
  });

  return (
    <FixedModal
      dataTest='cookies_checker_modal'
      showModal={!cookiesEnabled}
      title={<Typography variant='h2' component='span'>Ошибка: Cookies отключены</Typography>}
      content={<CookiesErrorContent />}
      buttonLabel='Понятно'
    />
  );
};
